module.exports = __webpack_public_path__ + "static/media/ic_02_operationorientated.e75777c4.svg";